import React from "react";
import { Copy, Eye, Pencil, Trash2 } from "lucide-react";
import IconAction from "../../../components/IconAction";

// Row actions of the Template list. Edit, Copy and Delete are Super Admin only (`canManage`).
// `busy` = { id, action } of a request in flight.
export default function TemplateRowActions({ row, canManage, busy, onView, onEdit, onClone, onDelete }) {
  const isBusy = (action) => busy?.id === row.id && busy.action === action;
  const anyBusy = busy?.id === row.id;
  return (
    <div className="flex items-center gap-1">
      <IconAction label="View" icon={Eye} onClick={() => onView(row)} busy={isBusy("view")} disabled={anyBusy} />
      {canManage && (
        <>
          <IconAction label="Edit" icon={Pencil} tone="primary" onClick={() => onEdit(row)} disabled={anyBusy} />
          <IconAction label="Copy" icon={Copy} onClick={() => onClone(row)} busy={isBusy("clone")} disabled={anyBusy} />
          {!row.is_system && <IconAction label="Delete" icon={Trash2} tone="danger" onClick={() => onDelete(row)} disabled={anyBusy} />}
        </>
      )}
    </div>
  );
}
